import { useEffect, useState } from "react";
import api, { apiError } from "@/lib/api";
import { toast } from "sonner";
import { Paperclip, X, Plus } from "lucide-react";

export const MIN_MOT = 150;
export const GUIDA = "Spiega ai soci cosa chiedi e perché: situazione del cliente, cosa hai già provato, cosa succede se non viene approvato.";
import { TIPOLOGIE_GRUPPI } from "@/lib/catalogo";
export const TIPOLOGIE = TIPOLOGIE_GRUPPI.flatMap(([, l]) => l);
export const MOTIVI_SCONTO = ["Concorrenza", "Cliente ricorrente", "Immobile di valore basso", "Trattativa a rischio", "Altro"];
const inp = "w-full px-3 py-2.5 rounded-lg bg-white border border-[var(--border)] focus:border-[#FC82ED] outline-none text-sm";
const lab = "block text-xs font-semibold uppercase tracking-wide text-[var(--muted)] mb-1 mt-3";

export function Motivazione({ value, onChange, testid = "rich-motivazione" }) {
  const n = (value || "").trim().length;
  return (
    <div>
      <label className={lab}>Motivazione *</label>
      <textarea data-testid={testid} value={value} onChange={(e) => onChange(e.target.value)} rows={5} placeholder={GUIDA} className={inp} />
      <p data-testid={`${testid}-count`} className={`text-[11px] mt-1 ${n >= MIN_MOT ? "text-emerald-600" : "text-red-600"}`}>{n}/{MIN_MOT} caratteri minimi</p>
    </div>
  );
}

export function Allegati({ value, onChange, label = "Allegati", testid = "rich-allegati" }) {
  const [busy, setBusy] = useState(false);
  const up = async (e) => {
    setBusy(true);
    for (const f of Array.from(e.target.files || [])) {
      const fd = new FormData(); fd.append("file", f);
      try { const { data } = await api.post("/richieste/allegati", fd); onChange((v) => [...v, data]); } catch (err) { toast.error(apiError(err)); }
    }
    e.target.value = ""; setBusy(false);
  };
  return (
    <div>
      <label className={lab}>{label}</label>
      <div className="flex flex-wrap gap-1.5 items-center">
        {value.map((a) => <span key={a.id} className="inline-flex items-center gap-1 pl-2.5 pr-1 py-1 rounded-full bg-slate-100 text-xs"><Paperclip size={11} /> {a.nome}
          <button type="button" onClick={() => onChange((v) => v.filter((x) => x.id !== a.id))}><X size={12} /></button></span>)}
        <label className="inline-flex items-center gap-1 px-3 py-1 rounded-full border border-dashed border-[var(--border)] text-xs font-semibold cursor-pointer">{busy ? "Caricamento…" : <><Plus size={12} /> Aggiungi</>}
          <input data-testid={testid} type="file" multiple className="hidden" onChange={up} /></label>
      </div>
    </div>
  );
}

export function Prov({ label, value, onChange, testid }) {
  return (
    <div>
      <label className="block text-[11px] font-semibold text-[var(--muted)] mb-1">{label}</label>
      <div className="flex gap-1">
        <input data-testid={`${testid}-valore`} type="number" min="0" step="0.1" value={value.valore} onChange={(e) => onChange({ ...value, valore: e.target.value })} className={`${inp} flex-1 min-w-0`} />
        <select data-testid={`${testid}-tipo`} value={value.tipo} onChange={(e) => onChange({ ...value, tipo: e.target.value })} className={`${inp} w-[92px]`}><option value="pct">%</option><option value="forfait">€ forfait</option></select>
      </div>
    </div>
  );
}

export function Storico({ items }) {
  if (!items?.length) return null;
  return (
    <div className="mt-2 space-y-1.5" data-testid="storico-chiarimenti">
      {items.map((c) => (
        <div key={c.id} className="rounded-lg bg-sky-50 border border-sky-200 p-2.5 text-xs">
          <div><b>Domanda di {c.da}:</b> {c.domanda}</div>
          <div className="mt-1">{c.risposta ? <><b>Risposta:</b> {c.risposta}</> : <i className="text-sky-700">In attesa di risposta…</i>}</div>
        </div>
      ))}
    </div>
  );
}

export const apriAllegato = async (a) => { try { const r = await api.get(`/richieste/allegati/${a.id}`, { responseType: "blob" }); window.open(URL.createObjectURL(r.data), "_blank"); } catch (e) { toast.error(apiError(e)); } };

export function useSpesaAppr() {
  const [need, setNeed] = useState(false);
  const [c, setC] = useState({ motivazione: "", scopo: "" });
  const [allegati, setAllegati] = useState([]);
  useEffect(() => { api.get("/richieste/spesa-approvazione").then((r) => setNeed(!!r.data?.richiesta)).catch(() => {}); }, []);
  const ok = (importo, fornitore) => !need || (c.motivazione.trim().length >= MIN_MOT && c.scopo.trim() && (fornitore || "").trim() && importo > 0 && (importo <= 200 || allegati.length > 0));
  const payload = need ? { motivazione: c.motivazione, scopo: c.scopo, allegati: allegati.map((a) => a.id) } : {};
  const campi = (importo) => need && (
    <div data-testid="spesa-approvazione-campi" className="rounded-xl border border-[#FC82ED]/40 bg-[#FC82ED]/5 p-3">
      <p className="text-xs font-bold text-[#B8369F]">Questa spesa va in approvazione ai Soci</p>
      <label className={lab}>A cosa serve *</label>
      <input data-testid="spesa-scopo" value={c.scopo} onChange={(e) => setC({ ...c, scopo: e.target.value })} className={inp} />
      <Motivazione value={c.motivazione} onChange={(v) => setC({ ...c, motivazione: v })} testid="spesa-motivazione" />
      <Allegati value={allegati} onChange={setAllegati} label={importo > 200 ? "Preventivo * (obbligatorio oltre 200 €)" : "Preventivo (facoltativo)"} testid="spesa-preventivo" />
    </div>
  );
  return { need, ok, payload, campi };
}
